import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

import { TiposTablaComunConstant } from 'constants/index'

import * as TablaComunService from 'services/tablasComunes.service'

const DepartamentoFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  const [departamentos, setDepartamentos] = React.useState([])

  React.useEffect(() => {
    TablaComunService.getAsSelect(TiposTablaComunConstant.DEPARTAMENTO).then(({ data }) =>
      setDepartamentos(data)
    )
  }, [])

  return (
    <Form.Group>
      <Form.Label text='DEPARTAMENTO' htmlFor='select-idDepartamento' md={4} alignRightAt='md' />
      <Col md={8}>
        <Field name='_idDepartamento'>
          {({ field }) => (
            <Form.Select
              {...field}
              id='select-idDepartamento'
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
            >
              <option value=''>Seleccionar</option>
              {departamentos.map((val, key) => (
                <option key={key} value={val._id}>
                  {val.nombre}
                </option>
              ))}
            </Form.Select>
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(DepartamentoFormGroup)
